<template>
  <div class="cliente-main-apartado" v-if="arrayArticulos.length > 0">
    <div class="d-inline-block w-100 pr-3">
      <div class="cliente-main-apartado-titulo float-left">Compras recientes</div>
      <div><a class="unishop-button-secondary unishop-keep-shopping float-right" @click="openModal">Tickets</a></div>
    </div>
    <div class="apartado-slider">
      <splide :options="options" :slides="arrayArticulos">
        <splide-slide v-for="(articulo, index) in arrayArticulos" :key="index">
          <cliente-articulo :producto="articulo" :foto="getFoto(articulo.id_artic)" />
        </splide-slide>
      </splide>
    </div>
    <v-dialog v-model="modal">
      <v-card class="search">
        <v-toolbar flat class="d-flex justify-space-between">
          <v-toolbar-title class="primary-color">
            <v-icon class="mr-3 primary-color">person_add</v-icon>
            Tickets</v-toolbar-title
          >
          <v-btn @click="modal = false" icon flat class="primary-color">
            <v-icon>close</v-icon>
          </v-btn></v-toolbar
        >
        <v-card-text>
          <modal-tickets class="modal-overlay" v-if="modal" :tickets="tickets" :fotos="fotos"></modal-tickets>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import ClienteArticulo from './ClienteArticulo.vue';
import ModalTickets from './ModalTickets';
import EventBus from '@/plugins/EventBus';
import { ClienteApiService } from '@/api/ClienteApiService';
const clienteApiService = new ClienteApiService();

export default {
  name: 'clienteRecomendados',
  components: {
    ClienteArticulo,
    Splide,
    SplideSlide,
    ModalTickets,
  },
  data() {
    return {
      options: {
        rewind: false,
        gap: '2px',
        fixedWidth: '200px',
        arrows: true,
        pagination: false,
      },
      arrayArticulos: [],
      modal: false,
      clienteUid: '',
      tickets: {},
      fotos: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getAllTickets();
    },
    getAllTickets() {
      clienteApiService
        .getAllTickets(this.$store.getters.getCliente.uid)
        .then((data) => {
          this.arrayArticulos = data.articulos;
          this.tickets = data.tickets;
          this.fotos = data.articulosFotos;
          if (data.bi) {
            EventBus.$emit('clienteBiUpdate', data.bi);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    openModal() {
      this.modal = true;
    },
    getFoto(idArtic) {
      if (this.fotos.find((foto) => foto.articulo === idArtic)) {
        return this.fotos.find((foto) => foto.articulo === idArtic).url;
      }
    },
  },
};
</script>
